'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Signature = function Signature(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M21.4,9.07l-2.996-2.997l-7.99,7.99v2.997h2.996L21.4,9.07z M23.766,6.705c0.312-0.312,0.312-0.815,0-1.126l-1.869-1.87\n\tc-0.311-0.312-0.814-0.312-1.127,0l-1.566,1.566l2.996,2.997L23.766,6.705z"
  }), React__default["default"].createElement("path", {
    fill: "none",
    d: "M24,3.002"
  }), React__default["default"].createElement("path", {
    fill: "none",
    d: "M0,3.002"
  }), React__default["default"].createElement("rect", {
    y: "19.5",
    width: "24",
    height: "2.333"
  }), React__default["default"].createElement("polygon", {
    points: "3.99,12.084 2.496,13.578 0.994,12.084 0,13.077 1.501,14.572 0.007,16.066 1.001,17.061 2.496,15.565 3.99,17.061\n\t4.983,16.066 3.489,14.572 4.983,13.077 "
  }), React__default["default"].createElement("polygon", {
    points: "4.983,16.066 3.99,17.061 2.496,15.565 1.001,17.061 0.007,16.066 1.501,14.572 0,13.077 0.994,12.084\n\t2.496,13.578 3.99,12.084 4.983,13.077 3.489,14.572 "
  }));
};

var Signature$1 = iconStyles()(Signature);

module.exports = Signature$1;
